module.exports = "pegasus/assets/background-patterns/escheresque.png";